// 添加样式依赖
import '@/common/css/index.scss';
import './index.scss';
import '@/common/js/responsive.js';
